import React from 'react';
import Header from '../components/Header';
import MailForm from '../components/MailForm';

function Mail() {
  return (
    <>
      <Header />
      <MailForm />
    </>
  );
}

export default Mail;
